import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';

import StorePresenter from '../../presenters/StorePresenter';
import {
  validationSchema,
  initialValues,
} from '../../forms/transactionsFiltersForm';

import Form from './components/Form';

const TransactionsFilters = (props) => {
  const {
    searchParams,
    onSearchParamsChange,
    stores,
    storesLoadingState,
    onLoadData,
  } = props;
  const handleSubmit = (values, _actions) => {
    const nameNotIContAll = values.nameNotIContAll.replace(/ /g, '').split(',');
    const newParams = {
      ...searchParams,
      q: { ...values, nameNotIContAll },
    };
    onSearchParamsChange(newParams);
    onLoadData(newParams);
  };

  return (
    <Formik
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={(values, actions) => handleSubmit(values, actions)}
      initialValues={initialValues(searchParams)}
      validationSchema={validationSchema}
    >
      {(props) => (
        <Form
          {...props}
          stores={stores}
          storesLoadingState={storesLoadingState}
        />
      )}
    </Formik>
  );
};

export default TransactionsFilters;

TransactionsFilters.propTypes = {
  searchParams: PropTypes.shape().isRequired,
  onSearchParamsChange: PropTypes.func.isRequired,
  onLoadData: PropTypes.func.isRequired,
  stores: PropTypes.arrayOf(StorePresenter.shape()),
  storesLoadingState: PropTypes.string.isRequired,
};

TransactionsFilters.defaultProps = {
  stores: null,
};
